import { j as e, c as t } from "./createRuntimeFn-62c9670f.esm-CXdMsbWY.js";
/* empty css                              */
import { B as i } from "./Typography-2ZjCxfuP.js";
const o = () => /* @__PURE__ */ e.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8 2L14 3.2L9.19976 7.99994L14 12.8L12.8 14L7.99994 9.19976L3.2 14L2 12.8L6.79928 7.99994L2 3.2L3.2 2L7.99994 6.79928L12.8 2Z",
        fill: "#BC4646"
      }
    )
  }
), a = () => /* @__PURE__ */ e.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.3484 2L14.6667 3.1916L6.00701 14L1.33337 9.82676L2.44729 8.41938L5.80333 11.4157L13.3484 2Z",
        fill: "#529A46"
      }
    )
  }
), g = () => /* @__PURE__ */ e.jsx(
  "svg",
  {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ e.jsx(
      "path",
      {
        d: "M8.00002 3.99325L13.02 12.6666H2.98002L8.00002 3.99325ZM8.00002 1.33325L0.666687 13.9999H15.3334L8.00002 1.33325ZM8.66669 10.6666H7.33335V11.9999H8.66669V10.6666ZM8.66669 6.66659H7.33335V9.33325H8.66669V6.66659Z",
        fill: "#CC9A36"
      }
    )
  }
);
var c = t({ defaultClassName: "lg8yeu0", variantClassNames: { theme: { dark: "lg8yeu1", light: "lg8yeu2" }, status: { error: "lg8yeu3", success: "lg8yeu4", warning: "lg8yeu5" } }, defaultVariants: {}, compoundVariants: [] });
const d = {
  error: /* @__PURE__ */ e.jsx(o, {}),
  success: /* @__PURE__ */ e.jsx(a, {}),
  warning: /* @__PURE__ */ e.jsx(g, {})
}, w = ({
  children: n,
  icon: r,
  status: s,
  theme: l = "light"
}) => /* @__PURE__ */ e.jsxs("span", { className: c({ status: s, theme: l }), children: [
  s ? d[s] : r,
  /* @__PURE__ */ e.jsx(i, { size: "s", noMargin: !0, children: n })
] });
export {
  w as B
};
//# sourceMappingURL=Badge-BE18ezuy.js.map
